import React, { useEffect, useState } from 'react'
import { gql, useLazyQuery } from '@apollo/client';
import { loader } from 'graphql.macro';
import { __error, __yellow } from 'Common/scripts/consoleHelper';
import { mongoToDate, parseNewLine } from 'Common/scripts/Functions';
import { Affix, Alert, Card, Col, Divider, Image, Row, Space, Tag, Timeline } from 'antd';
import { Button, DevBlock, Drawer, Icon, IconButton, Loader } from 'Common/components';
import { defaultDateFormat, defaultDateTimeFormat } from 'configs';
import { DorNotesForm } from './components';
import { connect } from "react-redux";
import { ContentArea } from 'Layout_v1';
import { TimelineView } from './components/timelineView';

// const RECORD = loader('src/Graphql/dors/dors.graphql');
const RECORD = loader('src/Graphql/dors/getDor.graphql');
const img_fallback = `data:image/png;base64,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`

function DorDetails(props) {
  const [data, setData] = useState(props.data)
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState(null)
  const [showNoteForm, set_showNoteForm] = useState(false);

  const id = props?.match?.params?.id;

  const [getDor, dor_results] = useLazyQuery(RECORD, 
    // { variables: { id: match?.params?.site_id } }
  );

  useEffect(() => {
    if (dor_results.called || !id) return;
    fetchDor();
  }, [])

  const fetchDor = async() => {
    console.log(__yellow("fetchDor()"))
    setBusy(true);

    let results = await getDor({ variables: { filter: JSON.stringify({ _id: id }) } }).then(r => (r?.data?.getDor))
    .catch(err=>{
      console.log(__error("Error: "), error)
      return { error:{message:"Unable to fetch DOR"}}
    })

    setBusy(false);
    if (!results || results.error){
      setError((results && results?.error?.message) || "No recrods found");
      return false;
    }

    setData(results);
  }

  const onUpdate = (updates) => {
    setData(updates);
    set_showNoteForm(false)
    if (props.onUpdate) props.onUpdate(updates);
  }

  if (dor_results.loading) return <Loader loading={true} />
  if (error) return <Alert message={error} showIcon type='error' />
  if (!data) return null;

  let _notes =  data?.notes?.slice()?.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));


  return (<>
    <ContentArea style={{}}>
      <Loader loading={busy}>
        <Row gutter={[20]}>
          <Col flex="auto">{data.user.name}</Col>
          <Col><Tag color={data.locked ? "red" : "green"}>{data.locked ? "Locked" : "Open"}</Tag></Col>
          {/* {data.locked && <Col><Tag color={data.locked ? "red" : "green"}>{data.locked ? "Locked" : "Open"}</Tag></Col>} */}
          {/* {!data.locked && <Col><Button color={data.locked ? "red" : "green"}>Close DOR</Button></Col>} */}
          <Col>DOR Date: {mongoToDate(data.record_date).format(defaultDateFormat)}</Col>
          <Col>Creation Date: {mongoToDate(data.created_at).format(defaultDateTimeFormat)}</Col>
        </Row>

        <Card>
          <TimelineView dataArray={_notes} />
        </Card>
        
      </Loader>

    </ContentArea>

    <Drawer title="Add New Notes" placement="top" height="500px" visible={showNoteForm} onClose={() => set_showNoteForm(!showNoteForm)} footer={false}>
      {(!data.locked && showNoteForm) && <DorNotesForm onUpdate={onUpdate} dor_id={data._id} />}
    </Drawer>

    {/* <div style={{ position: "fixed", bottom: 0, right: 0 }}>
      <div style={{ backgroundColor: "red" }}>aaaaaaaa</div>
    </div> */}

    {(!data.locked && props?.user?._id == data?.user?._id) && <div style={{ position: "fixed", bottom: 50, right: 50 }}>
        <IconButton size="large" type="danger" icon="plus"
          style={{ boxShadow: '0 10px 16px 0 rgba(0,0,0,0.2),0 6px 20px 0 rgba(0,0,0,0.19)' }} // disabled={!modulePermissions['noticeboard.note.add']}
          onClick={() => set_showNoteForm(!showNoteForm)}
        />
    </div>}

    {/* {(!data.locked && props?.user?._id == data?.user?._id) && <Affix offsetTop={-120}>
      <div style={{ position: "absolute", bottom: 40, right: 40, textAlign: 'right' }}>
        <IconButton size="large" type="danger" icon="plus"
          style={{ boxShadow: '0 10px 16px 0 rgba(0,0,0,0.2),0 6px 20px 0 rgba(0,0,0,0.19)' }} // disabled={!modulePermissions['noticeboard.note.add']}
          onClick={() => set_showNoteForm(!showNoteForm)}
        />
      </div>
    </Affix>}
 */}
  </>)
}

const mapStateToProps = ({ ep_admin }, ownProps) => {
  return ({ user: ep_admin.user });
}
export default connect(mapStateToProps)(DorDetails);
